import { call, put, select } from "redux-saga/effects";
import { disconnectZapierFailure, disconnectZapierSuccess } from "../actionCreators";
import { IntegrationService } from "../integration.service";

export function* handleDisconnectZapier() {
    try {
        const formId: string = yield select(state => state.forms.current._id);
        const response: { data: any } = yield call(IntegrationService.disconnectZapier, formId);

        yield put(
            disconnectZapierSuccess({
                success: true,
                message: response.data?.message || "Zapier disconnected successfully",
                data: response.data,
            }),
        );
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || "Failed to disconnect Zapier";
        yield put(disconnectZapierFailure(errorMessage));
    }
}
